<!--<soho-expandable-area  [ngClass]="{'hide-show-more': true}">-->
<!--  <soho-expandable-header>-->
<!--    <div class="col-header-container" (click)="toggleHeaders($event)">-->
<!--      <p class="col-header-title" (click)="toggleHeaders($event)"-->
<!--    >{{label}}<svg soho-icon [icon]="buttonIcon()" class="icon collapsible-header-icon"></svg>-->
<!--      </p>-->
<!--    </div>-->
<!--  </soho-expandable-header>-->
<!--  <soho-expandable-pane>-->
@if (displayedFields().length > 0) {
  <div class="lm-facade-fields-content scrollable-y">
    @for(field of displayedFields(); track field.name) {
      <div class="lm-facade-field-wrapper">
          <svg soho-icon class="lm-facade-field-icon" [icon]="field.icon" soho-tooltip [content]="field.tooltip"/>
          <span class="lm-facade-field-label" soho-tooltip [content]="field.name"><p>{{ field.name }}</p></span>
<!--        <div class="facade-field-label"><span soho-tooltip [content]="field.name">{{ field.name }}</span></div>-->
      </div>
    }
  </div>
}
@if (displayedFilterFields().length > 0) {
  <div class="tags-wrapper">
    @for(field of displayedFilterFields(); track field.id) {
      <div class="tag-container">
        @if(field.and) {
          <div class="tag"><span>{{ 'And' | translate }}</span></div>
        } @else if (field.or) {
          <div class="tag"><span>{{ 'Or' | translate }}</span></div>
        } @else {
          <div class="tag lm-filter-tag"><span soho-tooltip [content]="field.label">{{ field.label }}</span></div>
        }
      </div>
    }
  </div>
}
@if (sortBy) {
  <div class="tags-wrapper">
    @for (field of sortBy.sortFields; track field.name; let i = $index) {
       <div class="tag-container">
           @if (i > 0) {
               <span>{{ 'Then' | translate }} </span>
           }
         <div class="tag"><span soho-tooltip [content]="field.name">
            {{ field.name }}
        @if (field.descending) {
          <svg soho-icon class="lm-facade-sort-icon" [icon]="'sort-z-to-a'" soho-tooltip [content]="'Descending' | translate"/>
        }</span></div><br>
        </div>
    }
  </div>
}
<!--  </soho-expandable-pane>-->
<!--</soho-expandable-area>-->
